import * as Yup from "yup";

export const LoginFormValidation = Yup.object().shape({
  email: Yup.string().email("Valid Email Required*").required("Email Required"),
  password: Yup.string().required("Password Required"),
});

export const SignupFormValidation = Yup.object().shape({
  username: Yup.string().required("User Name Required*").matches(/^[a-z0-9_-]{5,20}$/, "Not a valid username format"),
  email: Yup.string().email("Valid Email Required*").required("Email Required"),
  password: Yup.string().required("Password Required"),
  repassword: Yup.string()
    .required("Password Required")
    .oneOf([Yup.ref("password"), null], "Your password doesn’t match*"),
  termsOfService: Yup.boolean()
    .oneOf([true], "Please agree the consent")
    .required("Please agree the consent"),
});

export const RecoverPasswordValidation = Yup.object().shape({
  email: Yup.string().email("Valid Email Required*").required("Email Required"),
});

export const ChangePasswordValidation = Yup.object().shape({
  password: Yup.string().required("Password Required"),
  repassword: Yup.string()
    .required("Password Required")
    .oneOf([Yup.ref("password"), null], "Your password doesn’t match*"),
});

export const PersonalInfoValidation = Yup.object().shape({
  username: Yup.string().required("Username Required*").matches(/^[a-z0-9_-]{5,20}$/, "Not a valid username format"),
  // firstName: Yup.string().required("First Name Required*").nullable(true),
  // lastName: Yup.string().required("Last Name Required*").nullable(true),
});


export const IdentityVerificationValidation = Yup.object().shape({
  firstName: Yup.string().required("First Name Required*"),
  lastName: Yup.string().required("Last Name Required*"),
  address: Yup.string().required("Address Required*"),
  town: Yup.string().required("Town Name is Required*"),
  city: Yup.string().required("City Name is Required*"),
  country: Yup.string().required("Country Name is Required*"),
  national: Yup.string().required("Nationality is Required*"),
});

export const InvestDetailValidation = Yup.object().shape({
  invest: Yup.string().required("Required"),
});